import { differenceInMinutes, isToday, isYesterday } from 'date-fns';
import { TFunction } from 'i18next';
import { useTranslation } from 'react-i18next';

const getDisplayValue = (timestamp: Date, t: TFunction<'cockpit', 'Timestamp'>) => {
  const now = new Date();

  // < 5 minutes = just now
  const minuteDifference = differenceInMinutes(now, timestamp);
  if (minuteDifference < 5) {
    return t('now');
  }

  if (minuteDifference < 60) {
    return t('minutes');
  }

  if (isToday(timestamp)) {
    return t('today', { timestamp });
  }

  if (isYesterday(timestamp)) {
    return t('yesterday');
  }

  return t('other', { timestamp });
};

export const useThreadSummaryTimestamp = (timestamp: Date) => {
  const { t } = useTranslation('cockpit', { keyPrefix: 'Timestamp' });

  return {
    displayValue: getDisplayValue(timestamp, t),
    tooltipValue: t('long', { timestamp }),
  };
};
